export default "__VITE_ASSET__CRRFZMhY__"